import { useEffect } from 'react';
import { globalLoader } from '@/utils/globalLoader';

export function useGlobalLoader(shouldShow: boolean) {
  // NOTE: Show or hide the global loader based on the shouldShow condition
  useEffect(() => {
    if (shouldShow) {
      globalLoader.show();
    } else {
      globalLoader.hide();
    }
  }, [shouldShow]);
}
